import { UserProfileData } from '@state/types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import { useGetCustomerAccountInfoQuery } from '@state/apiSlice';
import { Statuses, SubscriptionSource } from '@helpers';
import { useAppSelector } from '@hooks/useStore';
import { selectUserState } from '@state/user/userSlice';

const useGetCustomerInfo = (): {
  user: UserProfileData | undefined;
  isLoading: boolean;
  isSuspendedStatus: boolean;
  isStripeSubscription: boolean;
  isError: boolean;
  refetch: () => void;
  error: FetchBaseQueryError | SerializedError | undefined;
} => {
  const {
    data: user,
    isLoading,
    isFetching,
    error,
    isError,
    refetch
  } = useGetCustomerAccountInfoQuery(undefined, {
    refetchOnReconnect: true
  }); // TODO REWRITE task 857
  // const isLoading = false;
  // const isFetching = false;
  // const refetch = () => true;
  // const error = false;
  // const isError = false;
  // const user = useAppSelector(selectUserState);
  // console.log('user', user);
  const isSuspendedStatus = user?.profile?.state === Statuses.Suspend;
  const isStripeSubscription =
    user?.profile?.subscription_source === SubscriptionSource.Stripe ||
    user?.profile?.subscription_source === SubscriptionSource.Staff;

  return {
    user: user?.profile,
    isLoading: isLoading || isFetching,
    refetch,
    isSuspendedStatus,
    isStripeSubscription,
    error,
    isError
  };
};

export default useGetCustomerInfo;
